import { t as e } from "./icons-BQHDHs7w.js";
import { jsx as t } from "react/jsx-runtime";
//#endregion
//#region primitives/icon/index.ts
var n = ({ icon: n, ...r }) => {
	if (!n) return null;
	let i = e[n];
	return i ? /* @__PURE__ */ t(i, { ...r }) : null;
};
//#endregion
export { n as t };
